// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input__Input__s67N0","Label":"Input__Label___n-1m","InputElement":"Input__InputElement__2-aFx","Invalid":"Input__Invalid__1sl1p"};